/**
 * The home page (web-client-app D11), layout 1 Tighter (Gabriel 2026-10-20):
 * the hero, the studio's story and guide in one band, at most eight services
 * with See all services, and its events. Open times left the home; its piece
 * stays published for custom sites. Each part draws only what the studio
 * created and nothing when it has nothing, so a missing section leaves no
 * heading or rule behind. Below 768px a visitor gets the phone guest home
 * instead (frame C): the studio's About page as the app draws it; signed in,
 * the app's own Home (web-account-pages D8).
 *
 * Signed in (web-account-pages, signed-in-home.html Variant B Band 4): the
 * opening a little shorter without its buttons and facts, then the client's
 * band (welcome and next session, Waiting on you, Coming up), the services and
 * events, and About last.
 */
import { useWebSession } from '../api/session';
import { EventsRow } from '../pieces/events-row';
import { Hero } from '../pieces/hero';
import { Services } from '../pieces/services';
import { PhoneGuestHome } from '../phone/PhoneGuestHome';
import { PhoneSignedInHome } from '../phone/PhoneSignedInHome';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';
import { AboutBand } from './home/AboutBand';
import { SignedInBand } from './home/SignedInBand';
import band from './home/SignedInBand.module.css';

/** The most services the home lists before See all services. */
const HOME_SERVICES = { limit: 8 };
/** Signed in, the opening keeps the studio's name and line only. */
const SIGNED_IN_HERO = { showButtons: false, showFacts: false };

export function HomePage() {
  usePageTitle(null);
  const phone = useAppScreens();
  const signedIn = useWebSession().status === 'signedIn';
  if (phone) return signedIn ? <PhoneSignedInHome /> : <PhoneGuestHome />;
  if (signedIn) {
    return (
      <>
        <div className={band.hero}>
          <Hero options={SIGNED_IN_HERO} />
        </div>
        <SignedInBand />
        <Services options={HOME_SERVICES} />
        <EventsRow />
        <AboutBand />
      </>
    );
  }
  return (
    <>
      <Hero />
      <AboutBand />
      <Services options={HOME_SERVICES} />
      <EventsRow />
    </>
  );
}
